<template>
    <div class="content3">
      <data-table-sub-user
        :data="result"
        :header="header"
        :body="body"
      />
    </div>
  </template>
  
  <script>
  import DataTableSubUser from "@/views/components/table-components/DataTableSubCustomers.vue";
  import Axios from 'axios'
  export default {
    name: "employeeAccounts",
    data() {
      return {
        header: [
          { header: "name", key: "first_name" },
          { header: "mobileNumber", key: "mobile_number" },
          { header: "actions", key: "actions" },
        ],
        body: ["first_name", "email", "mobile_number"],
        pageName: "setting",
        result: []
      };
    },
    components: {
      DataTableSubUser,
    },
    async created() {
       this.result = await (await Axios.get('second-clients/index')).data.data
       
    }
  };
  </script>